/* eslint-disable class-methods-use-this */
import { VehicleDto } from '../dtos/vehicle-dto';
import { VehicleModelDto } from '../dtos/vehicle-model-dto';
import Vehicle from '../models/vehicle';
import { VehicleModel } from '../models/vehicle-model';
import BrandMapping from './brand-mapping';
import ModelMapping from './model-mapping';
import SumInsuredMapping from './sum-insured-dto';

export default class VehicleMapping {
  constructor(
    private brandMapping: BrandMapping,
    private modelMapping: ModelMapping,
    private sumInsuredMapping: SumInsuredMapping,
  ) {}

  getVehicleResponse(data: VehicleDto): Vehicle {
    return {
      circulationArea: data.areaCirculacion,
      personalUse: data.usoPersonal,
      hasPlate: data.tienePlaca,
      year: data.anio,
      vehicleType: data.tipoVehiculo,
      vehicleClass: data.claseVehiculo,
      riskType: data.tipoRiesgo,
      useType: data.tipoUso,
      verified: data.verificado,
      numberSeats: data.numeroAsientos,
      engineSerialNumber: data.numeroSerieMotor,
      chassisSerialNumber: data.numeroSerieChasis,
      brand: this.brandMapping.getBrandResponse(data.marca),
      model: this.modelMapping.getModelResponse(data.modelo),
      sumInsured: this.sumInsuredMapping.getSumInsuredResponse(
        data.sumaAsegurada,
      ),
      circulationAreaCode: data.codigoAreaCirculacion,
    };
  }

  getVehicleModelsResponse(data: VehicleModelDto[]): VehicleModel[] {
    const newModels = data.map((item: VehicleModelDto) => {
      return {
        riskType: item.tipoRiesgo,
        vehicleType: item.tipoVehiculo,
        vehicleClass: item.claseVehiculo,
        numberOfDoors: item.numeroPuertas,
        transmissionType: item.tipoTransmision,
        modelo: this.modelMapping.getModelResponse(item.modelo),
      };
    });
    return newModels;
  }

  formatPatchVehicleRequest(data: any): any {
    return {
      identificadorVehiculo: data.id,
      sumaAseguradaSeleccionada: data.sumInsuredSelected,
      numeroSerieMotor: data.engineSerialNumber,
      numeroSerieChasis: data.chassisSerialNumber,
    };
  }

  formatCreateVehicleRequest(data: Vehicle): any {
    return {
      placa: data?.plate,
      anio: data.year,
      tipoVehiculo: data.vehicleType,
      claseVehiculo: data.vehicleClass,
      tipoRiesgo: data.riskType,
      marca: this.brandMapping.formatBrandRequest(data.brand),
      modelo: this.modelMapping.formatModelRequest(data.model),
      numeroSerieChasis: data.chassisSerialNumber,
      numeroSerieMotor: data.engineSerialNumber,
    };
  }

  formatCreatePatchVehicleResponse(data: { identificadorVehiculo: string }): {
    id: string;
  } {
    return {
      id: data.identificadorVehiculo,
    };
  }

  formatGetChineseVehicleResponse(data: { habilitado: boolean }): {
    vehicleEnable: boolean;
  } {
    return {
      vehicleEnable: data.habilitado,
    };
  }
}
